export interface IListFilters {
  search: string
  status: '' | 'PENDENTE' | 'APROVADO' | 'REPROVADO'
  is_validated_by_secretary: '' | '1' | '0'
  teacher: string
  type: '' | 'trabalho-de-conclusão' | 'pesquisa-de-campo'
  course: {
    format: string
    name: string
  }
  created_at: {
    from: string
    to: string
  }
}

export enum EEntregaDeTrabalhoType {
  'trabalho-de-conclusão' = 'Trabalho de conclusão',
  'pesquisa-de-campo' = 'Pesquisa de campo'
}

export const viewableFormats = ['pdf', 'png', 'jpeg', 'jpg']

export interface IEntregaDeTrabalho {
  id: number
  public_id: string
  name: string
  responsable_name: string
  course: string
  format: string
  teacher: string
  'class-days': string
  'class-hours': string
  type: 'trabalho-de-conclusão' | 'pesquisa-de-campo'
  status: 'PENDENTE' | 'APROVADO' | 'REPROVADO'
  is_validated_by_secretary: boolean
  validated_by_secretary_user_name: string | null
  validated_by_secretary_at: string | null
  created_at: string
  review_grade: string
  review_teacher: string
  review_created_at: string
  time_taken_seconds: number | null
}

export interface IEntregaDeTrabalhoComplete {
  id: number
  public_id: string
  status: 'PENDENTE' | 'APROVADO' | 'REPROVADO'
  name: string
  cpf: string
  responsable_name: string | null
  responsable_cpf: string | null
  email: string
  phone: string
  format: string
  course: string
  teacher: string
  'class-days': string
  'class-hour-start': string
  'class-hour-ends': string
  type: 'trabalho-de-conclusão' | 'pesquisa-de-campo'
  is_validated_by_secretary: boolean
  created_at: string
  updated_at: string
  uploads: IEntregaDeTrabalhoUpload[]
  review: IEntregaDeTrabalhoReviewFilled | null
}

export interface IEntregaDeTrabalhoUpload {
  id: number
  original_name: string
  path: string
  size: string
  created_at: string
  updated_at: string
  submitted_by: 'student' | 'teacher'
}

export interface IEntregaDeTrabalhoReviewFilled {
  id: number
  entrega_de_trabalho_id: number
  user_id: number
  teacher: string
  course_load: string
  start_date: string
  end_date: string
  contract_number: string
  class_code: string
  observations: string
  grade: string
  created_at: string
  updated_at: string
}

export interface IStatistics {
  total: number
  pendente: number
  aprovado: number
  reprovado: number
}

export interface IReviewed {
  delayed: number
  not_delayed: number
}

export interface INotReviewed {
  delayed: number
  not_delayed: number
}

export interface IReviewTimeStatistics {
  reviewed: IReviewed
  not_reviewed: INotReviewed
  average_time_in_seconds: string
}

export interface IEntregaDeTrabalhoReview {
  teacher: string
  observations: string
  grade: string
}

/** Formato de ensino aceito pelo formulário público (ABRA-163). */
export type EntregaDeTrabalhoFormato = 'presencial' | 'online-ao-vivo'

/** Opção de curso/professor devolvida pelos endpoints públicos do formulário. */
export interface IEntregaDeTrabalhoOption {
  id: number
  name: string
}

/** Payload do formulário público, já com os nomes de campo esperados pela API. */
export interface IEntregaDeTrabalhoFormPayload {
  name: string
  cpf: string
  responsible: 'student' | 'other'
  responsable_name?: string
  responsable_cpf?: string
  email: string
  email_confirmation: string
  phone: string
  phone_confirmation: string
  format: EntregaDeTrabalhoFormato
  course_id: string
  teacher_id: string
  'class-days': string
  'class-hour-start': string
  'class-hour-ends': string
  type: 'pesquisa-de-campo' | 'trabalho-de-conclusão'
}
